<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import 'assets/css/public.css';
@import '../static/font/font.css';
#app {
  font-family: 'PingFang-SC-Medium';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
	font-size: 4.27vw;
}
/* 推荐-轮播图dot、图片样式 */
.van-swipe__indicator{width: 5px !important;height: 3px !important;background: #ff550a !important;opacity: 0.5 !important;border-radius: 3px !important;}
.van-swipe__indicator:not(:last-child) {margin-right: 5px !important;}
.van-swipe__indicator--active{width: 12px !important;opacity: 1 !important;}
.index-swipe .van-swipe__indicators{bottom: 8px !important;}
.index-swipe .index-swipe-img,.recommend-course,.video-list,.live-container{width: 89.34vw;}
.index-swipe .index-swipe-img{height: 100%;margin: 0 5.33vw;}
.index-swipe .index-swipe-img .van-image__img,.course-image .van-image__img,.course-count,
.video-list .video-list-imgbox .video-list-image .van-image__img,.buy-container .van-col .buy-item .video-list-image .van-image__img,
.detail-bg .detail-course-intro .detail-course-introimg .van-image__img{border-radius: 2.67vw;}
/* 头部导航样式 */
.van-tabs{width: 100%;position: fixed !important;top: 0;left: 0;z-index: 11;}
.van-tabs--line .van-tabs__wrap{box-shadow:0px 1px 5px 0px rgba(11,11,11,0.08);}
.van-tabs__line{bottom: 5.33vw !important;}
/* 推荐直播 */
.recommend-live .live-container .live-top-infos .live-bg-img .van-image__img{border-top-left-radius: 2.66vw;border-top-right-radius: 2.66vw;}
.guest-info-desc .guest-tx-box .guest-tx .van-image__img{border-radius: 50%;}
/* 推荐-课程 */
.course-list-container,.video-list{margin-top: 44px !important;}
.recommend-course,.video-list,.live-container{margin: 0 auto;}
.recommend-course .van-col .course-container .course-item:nth-child(odd){margin-right: 4vw;}
.course-item{width: 42.67vw;padding-top: 20px;}
.course-image-box,.course-image,.video-item,.video-image-box,.video-image{width: 100%;}
.course-image-box,.course-image,.video-image-box,.video-image{height: 42.67vw;}
.course-image-box{position: relative;}
.course-count{position: absolute;bottom: 5px;right: 5px;height: 5.34vw;line-height: 5.34vw;font-size: 2.94vw;color: #fff;background: rgba(0,0,0,0.3);padding: 0 2.67vw;}
.course-count-icon{background: url(../static/images/bofangliang.png) no-repeat left;background-size: 3.2vw 2.4vw;padding-left: 4vw;}
.course-title,.buy-container .van-col .buy-item .buy-item-info .buy-item-title,.list-container .list-item .list-item-title,
.signature{word-wrap:break-word;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
.course-title{font-size: 3.47vw;height: 9.6vw;margin-top: 3.34vw;}
/* 推荐-视频 */
.recommend-video .van-col .video-item .video-image-box .video-image .van-image__img{border-radius: 2.67vw 2.67vw 0px 0px;}
/* 我的页面头像样式 */
.userinfo-box .personal-img .van-image__img,.detail-bg .list-bg .lectinfo-container .lectinfo-personalinfo .lectinfo-tx .van-image__img,
.detail-bg .list-bg .lectinfo-container-more .lectinfo-container-more-item .lectinfo-tx .van-image__img{border-radius: 50%;}
/* 课程分类导航样式 */
.van-tabs__nav{padding-left: 5px !important;}
.van-tab{color: #717784 !important;font-size: 4vw !important;padding: 0 15px !important;flex-basis: auto !important;}
[class*=van-hairline]::after{box-shadow: 0px 1px 5px 0px rgba(11,11,11,0.08);}
.van-tab--active{color: #ff550a !important;}
/* background:linear-gradient(150deg,rgba(251,76,76,1) 0%, rgba(254,133,0,1) 100%);
-webkit-background-clip:text;
-webkit-text-fill-color:transparent; */
.van-tabs__line{width: 13px !important;bottom: 20px;background: linear-gradient(151deg,rgba(251,76,76,1),rgba(254,133,0,1));border-radius: 3px;} 
/* 课程详情图片 */
.list-container .list-item .list-item-imgbox .list-item-img .van-image__img{border-radius: 1.34vw;}
/* 个人资料上传图片 */
.van-uploader__upload,.van-uploader__preview{margin: 0;}
.van-uploader__upload,.van-uploader__preview-image,.van-uploader__preview-image .van-image__img,.userdata-defaultimg{border-radius: 50%;}
.van-uploader__upload,.van-uploader__preview-image,.van-uploader__preview-image .van-image__img,
.van-uploader__preview-delete,.userdata-defaultimg,.van-uploader__input,.van-uploader__wrapper,
.van-uploader__input-wrapper{width: 13.34vw;height: 13.34vw;}
.van-uploader__preview-delete{opacity: 0;}
/* 绑定手机号filed部分去除阴影 */
[class*=van-hairline]::after{box-shadow: none !important;border: 0 !important;}
/* 课程详情按钮默认样式修改 */
.detail-statu-btn .van-button--default,.detail-statu-btn .van-button:before{line-height: 9.34vw;border: none !important;
background: linear-gradient(120deg,rgba(251,76,76,1),rgba(254,133,0,1)) !important;color: #fff !important;}
.detail-statu-btn .van-button{width: 48vw !important;height: 9.34vw !important;font-size: 4vw !important;line-height: 9.34vw !important;
border-radius: 4.8vw !important;position: absolute !important;top: 0;left: 0;}
.van-button--normal{padding: 0 !important;font-size: 4vw !important;}
</style>



// WEBPACK FOOTER //
// src/App.vue